import { TextField, TextFieldProps } from "@mui/material";
import React from "react";

const EditorVisualTextField: React.FC<TextFieldProps> = (props) => {
  return <TextField {...props} />;
};

export default EditorVisualTextField;
